import axios from "axios";

export const getAuthToken = async (oAuthConfig) => {

  return axios.post(
    oAuthConfig.token_url,
    {
      client_id: oAuthConfig.client_id,
      client_secret: oAuthConfig.client_secret,
      audience: oAuthConfig.audience,
      grant_type: 'client_credentials',
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const getAccountDetails = async (accountId, apiUrls, oAuthConfig) => {
  const bearertoken = await getAuthToken(oAuthConfig);
  return axios.get(
    `${apiUrls.account}?hashId=${encodeURIComponent(accountId)}`,
    {
      headers: {
        Authorization: `Bearer ${bearertoken.data.access_token}`,
      },
    }
  );
};

export const postAccountDetails = async ( data, apiUrls, oAuthConfig) => {
  const bearertoken = await getAuthToken(oAuthConfig);
  return axios.post(
    `${apiUrls.account}/Admin/Provision`,
    data,
    {
      headers: {
        Authorization: `Bearer ${bearertoken.data.access_token}`,
      },
    }
  );
};